 <script>
import { formatPrice, vatPrice } from '../../../../../Greativ/helper/price'
import { currency } from '@/stores/basket'
import {
  countryOptions,
  selectedCountryId,
  setSelectedCountryId,
  countryCarrierOptions,
  selectedCarrierId,
  setSelectedCarrierId,
  countryCarrierItems,
  selectedCarrierItemId,
  setSelectedCarrierItemId,
  countryCarrierItemOptions,
  selectedCarrierItemOptionId,
  setSelectedCarrierItemOptionId,
  saveTransport,
  isSelectedCarrierParcelMachine,
  transportErrorKeys,
} from '@/stores/transport'

import SelectField from '@/components/Form/SelectField'
import SelectSearchableField from '@/components/Form/SelectSearchableField'

export default {
  components: {
    SelectField,
    SelectSearchableField,
  },
  props: {
    locked: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    let saveTimeout
    const triggerSave = async () => {
      clearTimeout(saveTimeout)
      saveTimeout = setTimeout(async () => {
        await saveTransport()
      }, 50)
    }

    return {
      formatPrice,
      vatPrice,
      currency,
      countryOptions,
      selectedCountryId,
      setSelectedCountryId,
      countryCarrierOptions,
      selectedCarrierId,
      setSelectedCarrierId,
      countryCarrierItems,
      selectedCarrierItemId,
      setSelectedCarrierItemId,
      countryCarrierItemOptions,
      selectedCarrierItemOptionId,
      setSelectedCarrierItemOptionId,
      triggerSave,
      isSelectedCarrierParcelMachine,
      transportErrorKeys,
    }
  },
}
</script>

<template>
  <SelectSearchableField
    :label="__('form.country_title')"
    :options="countryOptions"
    :disabled="locked"
    :model-value="selectedCountryId"
    @change="(value) => [setSelectedCountryId(value), triggerSave()]"
  />

  <div class="mt-8" v-if="countryCarrierOptions.length">
    <div
      class="mb-8 last:mb-0"
      v-for="carrier in countryCarrierOptions"
      :key="`c${carrier.value}`"
    >
      <div class="flex justify-between items-center">
        <label class="custom-radio">
          {{ carrier.label }}
          <input
            :value="carrier.value"
            type="radio"
            :checked="carrier.value === selectedCarrierId"
            :disabled="locked"
            @change.stop="
              (event) => [
                setSelectedCarrierId(event.target.value),
                triggerSave(),
              ]
            "
          />
          <span></span>
        </label>
        <div class="font-bold" v-if="carrier.value === selectedCarrierId">
          {{ formatPrice(vatPrice(carrier.price, carrier.vat)) }} {{ currency }}
        </div>
      </div>

      <p
        class="!text-6 italic !mt-4 !mb-4 whitespace-pre-line"
        v-if="carrier.info && carrier.value === selectedCarrierId"
        v-html="carrier.info"
      />

      <div
        class="mt-4"
        v-if="countryCarrierItems.length && carrier.value === selectedCarrierId"
      >
        <SelectSearchableField
          :label="
            countryCarrierItemOptions.length
              ? __('form.choose_city_title')
              : __('form.choose_location_title')
          "
          :options="countryCarrierItems"
          :disabled="locked"
          :model-value="selectedCarrierItemId"
          :error="transportErrorKeys.includes('carrier_item')"
          @change="(value) => [setSelectedCarrierItemId(value), triggerSave()]"
          v-if="countryCarrierItems.length > 1"
        />

        <div class="mt-4" v-if="countryCarrierItemOptions.length">
          <SelectSearchableField
            :label="
              isSelectedCarrierParcelMachine
                ? __('form.choose_parcel_machine_title')
                : __('form.choose_pickup_title')
            "
            :options="countryCarrierItemOptions"
            :disabled="locked"
            :model-value="selectedCarrierItemOptionId"
            :error="transportErrorKeys.includes('carrier_item_option')"
            @change="
              (value) => [setSelectedCarrierItemOptionId(value), triggerSave()]
            "
          />
        </div>
      </div>
    </div>
  </div>
</template>
